import api from '@src/api/clients';

const BILLING_BASE = 'dashboard/billing-profiles/';
const LEDGER_BASE = 'dashboard/threshold-charges/';

const cleanParams = (params = {}) =>
  Object.fromEntries(
    Object.entries(params).filter(
      ([, value]) => value !== undefined && value !== null && value !== '',
    ),
  );

// ── Fleet view (all profiles) ────────────────────────────────────────

export const fetchBillingFleet = (params = {}) =>
  api.request({
    url: `${BILLING_BASE}fleet/`,
    method: 'GET',
    payload: cleanParams(params),
  });

// ── BillingProfile CRUD ──────────────────────────────────────────────

export const fetchBillingProfileForClient = (clientId) =>
  api.request({
    url: `${BILLING_BASE}for-client/${clientId}/`,
    method: 'GET',
  });

export const createBillingProfile = (payload) =>
  api.request({
    url: BILLING_BASE,
    method: 'POST',
    payload,
  });

export const updateBillingProfile = (profileId, payload) =>
  api.request({
    url: `${BILLING_BASE}${profileId}/`,
    method: 'PATCH',
    payload,
  });

// ── Live status + ops actions ────────────────────────────────────────

export const fetchBillingLiveStatus = (profileId) =>
  api.request({
    url: `${BILLING_BASE}${profileId}/live-status/`,
    method: 'GET',
  });

export const chargeNow = (profileId) =>
  api.request({
    url: `${BILLING_BASE}${profileId}/charge-now/`,
    method: 'POST',
  });

export const resumeBilling = (profileId) =>
  api.request({
    url: `${BILLING_BASE}${profileId}/resume/`,
    method: 'POST',
  });

export const fetchPrepaidTerms = (profileId) =>
  api.request({
    url: `${BILLING_BASE}${profileId}/prepaid-terms/`,
    method: 'GET',
  });

export const enablePrepaid = (profileId, { termsVersion } = {}) =>
  api.request({
    url: `${BILLING_BASE}${profileId}/enable-prepaid/`,
    method: 'POST',
    payload: { terms_version: termsVersion },
  });

export const fetchPaymentMethods = (profileId) =>
  api.request({
    url: `${BILLING_BASE}${profileId}/payment-methods/`,
    method: 'GET',
  });

export const createSetupIntent = (profileId, paymentMethodType = 'card') =>
  api.request({
    url: `${BILLING_BASE}${profileId}/create-setup-intent/`,
    method: 'POST',
    payload: { payment_method_type: paymentMethodType },
  });

export const setDefaultPaymentMethod = (profileId, paymentMethodId) =>
  api.request({
    url: `${BILLING_BASE}${profileId}/set-default-payment-method/`,
    method: 'POST',
    payload: { payment_method_id: paymentMethodId },
  });

export const detachPaymentMethod = (profileId, paymentMethodId) =>
  api.request({
    url: `${BILLING_BASE}${profileId}/detach-payment-method/`,
    method: 'POST',
    payload: { payment_method_id: paymentMethodId },
  });

export const registerPendingBankVerification = (profileId, payload) =>
  api.request({
    url: `${BILLING_BASE}${profileId}/register-pending-verification/`,
    method: 'POST',
    payload,
  });

// ── Ledger history ───────────────────────────────────────────────────

export const listThresholdCharges = (params = {}) =>
  api.request({
    url: LEDGER_BASE,
    method: 'GET',
    payload: cleanParams(params),
  });

export const exportThresholdChargesCsvUrl = (params = {}) => {
  const qs = new URLSearchParams(cleanParams(params)).toString();
  const suffix = qs ? `?${qs}` : '';
  return `/api/${LEDGER_BASE}export-csv/${suffix}`;
};
